import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from "@angular/core";
import { IProcessingStatus, ProcessingStatus } from "app_sasha/shared/resources/processings/ProcessingStatus";


@Component({
    selector: 'processing-status-list',
    template: `
        <div class="col-to-row-s-tb">
            <processing-status *ngFor="let statusName of statusList"
                               [name]="statusName"
                               [count]="status[statusName]"
                               [select]="select"
                               [selectedStatus]="selectedStatus"
                               [statusSelected]="statusSelectedList[statusName]"
                               (onSelect)="selectFilter($event)">
            </processing-status>
        </div>
    `,
    styleUrls: ['./processing-status-list.component.scss']
})
export class ProcessingStatusListComponent implements OnChanges {
    public statusList: ProcessingStatus[] = [
        ProcessingStatus.Pending,
        ProcessingStatus.Processing,
        ProcessingStatus.Success,
        ProcessingStatus.Warning,
        ProcessingStatus.Error,
    ];

    public readonly statusSelectedList: { [key in ProcessingStatus]: boolean } = {
        [ProcessingStatus.Pending]: false,
        [ProcessingStatus.Processing]: false,
        [ProcessingStatus.Success]: false,
        [ProcessingStatus.Warning]: false,
        [ProcessingStatus.Error]: false,
    };

    @Input()
    public status: IProcessingStatus;

    @Input()
    public select: boolean;
    @Input()
    public selectedStatus: string;

    @Output()
    public readonly onSelect: EventEmitter<string> = new EventEmitter();

    public selectFilter(name: string): void {
        this.statusList.forEach((statusName: ProcessingStatus) => {
            this.statusSelectedList[statusName] = statusName === name ? this.statusSelectedList[statusName] === false : false;
        });
        this.onSelect.emit(this.statusSelectedList[name] ? name : null);
    }

    public ngOnChanges(changes: SimpleChanges): void {
        this.statusList = [
            ...(this.status && this.status.pending
                ? [ProcessingStatus.Pending]
                : []),
            ...(this.status && this.status.processing
                ? [ProcessingStatus.Processing]
                : []),
            ...(this.status && this.status.success
                ? [ProcessingStatus.Success]
                : []),
            ...(this.status && this.status.warning
                ? [ProcessingStatus.Warning]
                : []),
            ...(this.status && this.status.error
                ? [ProcessingStatus.Error]
                : []),
        ];
    }
}
